import { useQuery } from '@tanstack/react-query';
import { adminUserApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useAdminUsers() {
  return useQuery({
    queryKey: queryKeys.adminUsers.list(),
    queryFn: () => adminUserApi.listAdminUsers(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
